import { CommonModule, DatePipe } from '@angular/common';
import {
  Component,
  inject,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ToastrService } from 'ngx-toastr';
import { InvoiceService } from '../../../features/invoice/services/invoice.service';
import { ReportsComponent } from '../reports.component';

@Component({
  selector: 'app-profit-loss',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './profit-loss.component.html',
  styleUrl: '../reports.component.scss',
})
export class ProfitLossComponent implements OnChanges {
  @Input() profitLossData: any = {};
  @Input() startDate: string = '';
  @Input() endDate: string = '';
  // in your component

  ngOnChanges(changes: SimpleChanges) {
    if (changes['profitLossData']) {
      console.log('Updated profitLossData:', this.profitLossData);
    }
    if (changes['startDate'] || changes['endDate']) {
      console.log(
        `Date Range Updated: From ${this.startDate} to ${this.endDate}`
      );
    }
  }
}

@Component({
  selector: 'app-cash-flow-statement',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './cash-flow-statement.component.html',
  styleUrl: '../reports.component.scss',
})
export class CashFlowStatementComponent implements OnChanges {
  @Input() cashFlowReport: any = {};
  @Input() startDate: string = '';
  @Input() endDate: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['cashFlowReport']) {
      console.log('Updated cashFlowReport:', this.cashFlowReport);
    }
    if (changes['startDate'] || changes['endDate']) {
      console.log(
        `Date Range Updated: From ${this.startDate} to ${this.endDate}`
      );
    }
  }
}

@Component({
  selector: 'app-trial-balance-statement',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './trial-balance.component.html',
  styleUrl: '../reports.component.scss',
})
export class TrialBalanceComponent implements OnChanges {
  @Input() trialBalanceReport: any = {};
  @Input() startDate: string = '';
  @Input() endDate: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['trialBalanceReport']) {
      console.log('Updated trialBalanceReport:', this.trialBalanceReport);
    }
    if (changes['startDate'] || changes['endDate']) {
      console.log(
        `Date Range Updated: From ${this.startDate} to ${this.endDate}`
      );
    }
  }
}

@Component({
  selector: 'app-sales-by-item',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './sales-by-item.component.html',
  styleUrl: '../reports.component.scss',
})
export class SalesByItemComponent implements OnChanges {
  @Input() salesByItemReport: any = {};
  @Input() startDate: string = '';
  @Input() endDate: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['salesByItemReport']) {
      console.log('Updated SalesByItemReport:', this.salesByItemReport);
    }
    if (changes['startDate'] || changes['endDate']) {
      console.log(
        `Date Range Updated: From ${this.startDate} to ${this.endDate}`
      );
    }
  }
}

@Component({
  selector: 'app-aging-invoice',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './aging-invoice.component.html',
  styleUrl: '../reports.component.scss',
})
export class AgingInvoiceReport implements OnChanges {
  @Input() agingInvoiceReport: any = {};
  @Input() daysFilter: string = '';
  @Input() startDate: string = '';
  @Input() endDate: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['agingInvoiceReport']) {
      if (this.agingInvoiceReport && this.agingInvoiceReport.data) {
        this.agingInvoiceReport =
          this.agingInvoiceReport.data.getInvoiceAgingReport;
      }
      console.log('Updated AgingInvoiceReport:', this.agingInvoiceReport);
    }
    if (changes['startDate'] || changes['endDate']) {
      console.log(
        `Date Range Updated: From ${this.startDate} to ${this.endDate}`
      );
    }
  }

  getOverdueText(dueDate: string | Date): string {
    if (!dueDate) return '--';

    const today = new Date();
    const due = new Date(dueDate);
    today.setHours(0, 0, 0, 0);
    due.setHours(0, 0, 0, 0);

    const diffTime = today.getTime() - due.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays > 0) {
      return `Overdue by ${diffDays} day${diffDays > 1 ? 's' : ''}`;
    } else {
      return '--';
    }
  }
}

@Component({
  selector: 'app-aging-vendor-invoice',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './aging-vendor-invoice.component.html',
  styleUrl: '../reports.component.scss',
})
export class AgingInvoiceVendorReport implements OnChanges {
  @Input() agingVendorInvoice: any = {};
  @Input() daysFilter: string = '';
  @Input() startDate: string = '';
  @Input() endDate: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['agingVendorInvoice']) {
      if (this.agingVendorInvoice && this.agingVendorInvoice.data) {
        this.agingVendorInvoice =
          this.agingVendorInvoice.data.getInvoiceAgingReport;
      }
      console.log('Updated AgingInvoiceReport:', this.agingVendorInvoice);
    }
  }

  getOverdueText(dueDate: string | Date): string {
    if (!dueDate) return '--';

    const today = new Date();
    const due = new Date(dueDate);
    today.setHours(0, 0, 0, 0);
    due.setHours(0, 0, 0, 0);

    const diffTime = today.getTime() - due.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays > 0) {
      return `Overdue by ${diffDays} day${diffDays > 1 ? 's' : ''}`;
    } else {
      return '--';
    }
  }
}

@Component({
  selector: 'app-general-ledger-report',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './general-ledger-report.component.html',
  styleUrl: '../reports.component.scss',
})
export class GeneralLedgerReport implements OnChanges {
  @Input() generalLedgerReport: any = {};
  @Input() startDate: string = '';
  @Input() endDate: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['generalLedgerReport']) {
      console.log('Updated generalLedgerReport:', this.generalLedgerReport);
    }
    if (changes['startDate'] || changes['endDate']) {
      console.log(
        `Date Range Updated: From ${this.startDate} to ${this.endDate}`
      );
    }
  }
}

@Component({
  selector: 'app-accounts-report',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './account-report.component.html',
  styleUrl: '../reports.component.scss',
})
export class AccountReport implements OnChanges {
  @Input() accountReport: any = {};
  @Input() startDate: string = '';
  @Input() endDate: string = '';
  accountLedgerReport: any;
  ngOnInit() {
    this.accountLedgerReport = this.accountReport[0];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['accountReport']) {
      console.log('Updated accountReport:', this.accountReport);
      this.accountLedgerReport = this.accountReport[0];
    }
    if (changes['startDate'] || changes['endDate']) {
      console.log(
        `Date Range Updated: From ${this.startDate} to ${this.endDate}`
      );
    }
  }
}

@Component({
  selector: 'app-journal-report',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './journal-report.component.html',
  styleUrl: '../reports.component.scss',
})
export class JournalReport implements OnChanges {
  @Input() journalReport: any = {};
  @Input() startDate: string = '';
  @Input() endDate: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['journalReport']) {
      console.log('Updated journalReport:', this.journalReport);
    }
    if (changes['startDate'] || changes['endDate']) {
      console.log(
        `Date Range Updated: From ${this.startDate} to ${this.endDate}`
      );
    }
  }
  getTotalDebit(entries: any[]): number {
    if (!entries || entries.length === 0) return 0;
    return entries.reduce((sum, item) => sum + (item?.debit || 0), 0);
  }

  getTotalCredit(entries: any[]): number {
    if (!entries || entries.length === 0) return 0;
    return entries.reduce((sum, item) => sum + (item?.credit || 0), 0);
  }
}

@Component({
  selector: 'app-vat-report',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './vat-report.component.html',
  styleUrl: '../reports.component.scss',
})
export class VatReport implements OnChanges {
  @Input() vatReportData: any = {};
  @Input() startDate: string = '';
  @Input() endDate: string = '';
  vatPayable: any;
  vatReceivable: any;

  ngOnInit() {
    this.vatPayable = this.vatReportData?.vatPayable;
    this.vatReceivable = this.vatReportData?.vatReceivable;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['vatReportData']) {
      console.log('Updated vatReportData:', this.vatReportData);
      this.vatPayable = this.vatReportData?.vatPayable;
      this.vatReceivable = this.vatReportData?.vatReceivable;
    }
    if (changes['startDate'] || changes['endDate']) {
      console.log(
        `Date Range Updated: From ${this.startDate} to ${this.endDate}`
      );
    }
  }
}

@Component({
  selector: 'app-balance-sheet',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './balance-sheet.component.html',
  styleUrl: '../reports.component.scss',
})
export class BalanceSheetComponent implements OnChanges {
  @Input() balanceSheetReport: any = {};
  @Input() startDate: string = '';
  @Input() endDate: string = '';
  totalEquityLiability: any;

  sections = [
    { key: 'assets', totalKey: 'totalAssets', label: 'Assets' },
    { key: 'liabilities', totalKey: 'totalLiabilities', label: 'Liabilities' },
    { key: 'equity', totalKey: 'totalEquity', label: 'Equity' },
  ];

  ngOnInit() {
    const totalLiabilities = this.balanceSheetReport?.totalLiabilities;
    const totalEquity = this.balanceSheetReport?.totalEquity;
    this.totalEquityLiability = Number(totalLiabilities + totalEquity);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['balanceSheetReport']) {
      console.log('Updated balanceSheetReport:', this.balanceSheetReport);
      const totalLiabilities = this.balanceSheetReport?.totalLiabilities;
      const totalEquity = this.balanceSheetReport?.totalEquity;
      this.totalEquityLiability = Number(totalLiabilities + totalEquity);
    }
    if (changes['startDate'] || changes['endDate']) {
      console.log(
        `Date Range Updated: From ${this.startDate} to ${this.endDate}`
      );
    }
  }
}

@Component({
  selector: 'app-day-book-report',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './day-report.component.html',
  styleUrl: '../reports.component.scss',
})
export class DayReport implements OnChanges {
  @Input() dayBookReportData: any = {};
  @Input() chooseDate: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dayBookReportData']) {
      console.log('Updated dayBookReportData:', this.dayBookReportData);
    }
    if (changes['chooseDate']) {
      console.log(`Date Range Updated: From ${this.chooseDate} `);
    }
  }
}

@Component({
  selector: 'app-customer-balance-summary-report',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './customer-balance-summary.component.html',
  styleUrl: '../reports.component.scss',
})
export class CustomerBalanceSummaryReport implements OnChanges {
  @Input() customerBalanceSummaryReport: any = {};
  @Input() startDate: string = '';
  @Input() endDate: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['customerBalanceSummaryReport']) {
      console.log(
        'Updated customerBalanceSummaryReport:',
        this.customerBalanceSummaryReport
      );
    }
    if (changes['startDate'] || changes['endDate']) {
      console.log(
        `Date Range Updated: From ${this.startDate} to ${this.endDate}`
      );
    }
  }
}

@Component({
  selector: 'app-vendor-balance-summary',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './vendor-balance-summary.component.html',
  styleUrl: '../reports.component.scss',
})
export class VendorBalanceSummary implements OnChanges {
  @Input() vendorBalanceSummaryReport: any = {};
  @Input() startDate: string = '';
  @Input() endDate: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['vendorBalanceSummaryReport']) {
      console.log(
        'Updated vendorBalanceSummaryReport:',
        this.vendorBalanceSummaryReport
      );
    }
    if (changes['startDate'] || changes['endDate']) {
      console.log(
        `Date Range Updated: From ${this.startDate} to ${this.endDate}`
      );
    }
  }
}


@Component({
  selector: 'app-movement-trial-balance-statement',
  standalone: true,
  imports: [CommonModule, MatTabsModule, MatSelectModule],
  templateUrl: './movement-trial-balance.component.html',
  styleUrl: '../reports.component.scss',
})
export class MovementTrialBalanceComponent implements OnChanges {
  @Input() movementTrialBalanceReport: any = {};
  @Input() startDate: string = '';
  @Input() endDate: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['movementTrialBalanceReport']) {
      console.log('Updated movementTrialBalanceReport:', this.movementTrialBalanceReport);
    }
    if (changes['startDate'] || changes['endDate']) {
      console.log(
        `Date Range Updated: From ${this.startDate} to ${this.endDate}`
      );
    }
  }
}

